import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import BlogGrid from '../components/blog/BlogGrid';
import SEO from '../components/layout/SEO';

const BlogPage = () => {
  React.useEffect(() => {
    document.body.style.paddingTop = '50px';
    return () => {
      document.body.style.paddingTop = '0';
    };
  }, []);

  return (
    <HelmetProvider>
      <div className="blog-page">
        <SEO 
          title="Blog - Resumeslip" 
          description="Read our latest articles on career tips, resume writing, and professional development."
        />
        <BlogGrid />
      </div>
    </HelmetProvider>
  );
};

export default BlogPage;